import { createPoll, setCloseCreatePollModal, softPollReset } from 'features/polls/pollSlice'
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import PollIcon from '@mui/icons-material/Poll'; 
import { toast } from 'react-toastify'
import ClearIcon from '@mui/icons-material/Clear'; 
import ModalCloseButton from 'components/buttons/ModalCloseButton'

import SpinnerSmall from 'components/SpinnerSmall';
import { MdDriveFileRenameOutline } from "react-icons/md"; 
import { ButttonWrap, FileUploadButton } from 'components/files/files.styled';
import useToggleDropdown from 'hooks/useToggleDropdown'
import { ModalFormTop, CreateItemModalHeading, ModalItemInput } from 'components/modal/modal.styled';
import { MdOutlineVisibility } from "react-icons/md";
import TwoOptionButton from 'components/utils/TwoOptionButton';
import { useTranslation } from 'react-i18next'

export default function CreatePollModal() {
  const { t: translate } = useTranslation()
    const dispatch = useDispatch()
    const [title, setTitle] = useState('')
    const [choices, setChoices] = useState([])
    const [currentChoice, setCurrentChoice] = useState('')
    const [responseType, setResponseType] = useState('predetermined')
    const [choiceIndex, setChoiceIndex] = useState(0)
    const [viewResultSettings, setViewResultSettings] = useState('user')
    const { isPollCreatedLoading, isPollCreatedSuccess } = useSelector((state) => state.poll)
    const { user } = useSelector((state) => state.auth)
    const { profileChurch } = useSelector((state) => state.profileChurch)

    const ref = useRef(null)
    const [showMenu, setShowMenu] = useToggleDropdown(ref)

    const toggleDropdown = () => {
        setShowMenu.toggle(!showMenu)
    }
    const handleSubmit = () => {

        if(title.length === 0){
            return toast.error(translate("web:polls.toastErrorTitle"))
        }
  
        if(responseType === 'predetermined' && choices.length < 2){
           return toast.error(translate("web:polls.toastErrorAtLeastTwoChoices"))
        }

        dispatch(createPoll({
            churchId: profileChurch._id,
            title: title,
            viewResultsSettings: viewResultSettings,
            responseType: responseType,
            choices: JSON.stringify(choices)
        }))
    }

    const handleRemoveChoice = (choiceIndex) => {
        const filteredArray = choices.filter((choice, index) => index !== choiceIndex)
        setChoices(filteredArray)
    }


    const PollResponseItem = ({ choice, index }) => {
        return (
            <PRIC key={index}>
                <span> {choice} </span>
                <ClearChoice onClick={() => handleRemoveChoice(index)}>
                    < ClearIcon style={{fontSize: 'smaller'}} />
                </ClearChoice>
            </PRIC> 
        )
    }

    useEffect(() => {
        if(isPollCreatedSuccess){

            dispatch(setCloseCreatePollModal())
            toast.success(translate("web:polls.toastSuccess"))
            dispatch(softPollReset())

        }
    },[choices, isPollCreatedSuccess, dispatch])


    const handleAddChoiceItem = () => {
        if(currentChoice.length === 0){ return toast.error(translate("web:polls.toastErrorAddSomething")) }
        choices.push( currentChoice )
        setCurrentChoice('')
        setChoiceIndex(choiceIndex+1)
    }

    return (
        <PollModalWrap>                
            <ModalFormTop>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}> 
                    <PollIcon style={{   marginRight: '10px'}} />  
                    <CreateItemModalHeading>
                        {
                            translate("web:polls.createPoll")
                        }
                    </CreateItemModalHeading>
                </div>
                <ModalCloseButton
                    handler={() => dispatch(setCloseCreatePollModal())}
                    top='20px'
                    right='20px'
                    size='30px'
                    />
            </ModalFormTop>
            <CreatePollForm>
                <PollFormWrap> 
                    <PollResponsesWrap>
                        <ModalItemInput>
                            <MdDriveFileRenameOutline style={{color: 'grey', fontSize: '20px', marginRight: '10px'}} />
                            <input 
                                value={title} 
                                placeholder={translate("web:polls.pollTitle") }
                                onChange={(e) => setTitle(e.target.value)} 
                                />
                        </ModalItemInput>

                        <TwoOptionButton
                            componentLabel={"Response Type"}
                            label1={"Preset"}
                            label2={"Open"}
                            value1={"predetermined"}
                            value2={"open"}
                            valueToCheckIfSelected={responseType}
                            callback1={() => setResponseType('predetermined')}
                            callback2={() => setResponseType('open')}
                            />

                        
                        {
                            responseType === 'predetermined' &&
                            (choices.length < 10 ) && (
                                    <PollInput>
                                        <input 
                                            value={currentChoice} 
                                            placeholder={
                                                translate("web:polls.addResponseOption")
                                            }
                                            onChange={(e) => setCurrentChoice(e.target.value)} 
                                            />
                                        <button onClick={handleAddChoiceItem}>
                                            <span>
                                                {
                                                    translate("web:polls.add")
                                                }
                                            </span>  
                                        </button>
                                    </PollInput>
                            ) 
                        }
                        <div
                            style={{
                                width: '100%', 
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                            }}
                            > 
                          <ResponseTypeLabel>Responses</ResponseTypeLabel>  
                        </div> 
                        {
                            responseType === 'predetermined' ?
                            ( 
                                choices.map((item, index) => (
                                        <PollResponseItem choice={item} index={index} />
                                    )
                                ) 
                            )
                            :
                            (
                                <div 
                                    style={{
                                        color: 'grey',
                                        margin: '10px 0px',
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                    }}
                                    >
                                    {translate('polls:detail.openHint')}
                                </div>
                            )
                        }

                    </PollResponsesWrap>
                </PollFormWrap>
                <ButttonWrap
                    justify='space-between'
                    >
                    { 
                        showMenu && (
                            <ResultSettingsPopup >
                                <SettingItem
                                    selected={viewResultSettings === 'visible'}
                                    onClick={() => setViewResultSettings('visible')}
                                    >
                                    {translate('polls:management.settings.visible.title')}
                                </SettingItem>  
                                <SettingItem
                                    onClick={() => setViewResultSettings('user')}
                                    selected={viewResultSettings === 'user'}
                                    >
                                    {translate('polls:results.afterVoting')}
                                </SettingItem>
                                <SettingItem
                                    onClick={() => setViewResultSettings('hidden')}
                                    selected={viewResultSettings === 'hidden'}
                                    >
                                    {translate('polls:management.settings.hidden.title')}
                                </SettingItem> 
                            </ResultSettingsPopup>
                        )
                    } 
                    {
                        responseType === 'predetermined' && (
                            <div>
 
                            <ViewResultsButton
                                ref={ref}
                                onClick={
                                    toggleDropdown
                                }
                                >
                                <MdOutlineVisibility 
                                    style={{
                                        marginRight: '10px'
                                    }}
                                    />
                                {translate('polls:management.viewSettings')}
                            </ViewResultsButton>
                            
                            <div
                                style={{
                                    width: '70%',
                                    margin: '20px 0px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    color: 'grey',
                                    fontSize: '12px',
                                }}
                                >
                                {
                                    viewResultSettings === "user" ? 
                                    ( 
                                        "Poll status and results visible to each user only after they cast their vote. "
                                    )
                                    : viewResultSettings === "visible" ?
                                    (
                                        "Results always visible to users and admins. "
                                    )
                                    : viewResultSettings === "hidden" ?
                                    (
                                        "Results not visible to users, except admins. "
                                    ) 
                                    : null
                                }
                                {
                                    "Settings may be changed in the Poll Settings page at any time"
                                }
                            </div>

                            </div>
                        )
                    }

                    <FileUploadButton 
                        onClick={handleSubmit}
                        disabled={isPollCreatedLoading}
                        style={{marginBottom: '20px'}}
                        width={'150px'}
                        >
                        { isPollCreatedLoading ? 
                            (
                                <SpinnerSmall />
                            )
                            :
                            (
                                translate("web:polls.createButton")
                            )
                        }
                    </FileUploadButton>
                </ButttonWrap>
            </CreatePollForm>
        </PollModalWrap>
    )
}

const ViewResultsButton = styled.button`
    padding: 10px;
    border: none;
    background-color: #bababa;
    color: white;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

`

const SettingItem = styled.div`
    font-size: 12px;
    margin-bottom: 10px;
    padding: 10px;
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background-color: ${props => props.selected ? 'var(--themeColor)' : 'white'};
    color: ${props => props.selected ? 'white' : '#8a8a8a'};
    
    &:hover{
        background-color: ${props => props.selected ? 'var(--themeColor)' : '#e9e9e9;'};
    }
`

const ResponseTypeLabel = styled.div`
    font-size: 12px;
    color: #ccc;
    margin-top: 20px;
    width: 100px;
    font-weight: 500;
    margin-bottom: 10px;
`

const ResultSettingsPopup = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    padding: 5px;
    width: fit-content;
    height: fit-content;
    align-items: flex-start;
    justify-content: flex-start;
    left: 10px;
    bottom: 10px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
`
 
const CreatePollForm = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
`

const PollFormWrap = styled.div`
    display: flex;
    overflow-y: scroll;
    flex-direction: column;
    width: 100%;
`
const PollModalWrap = styled.div`
    z-index: 0;
    width: 960px;
    max-width: 92vw;
    min-height: 550px;
    max-height: 90vh;
    overflow-y: scroll;
    padding: 20px;
  /* remove scroll bar */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
    &::-webkit-scrollbar { /* WebKit */
        width: 0;   
        height: 0;
    }       


  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: start;
  border-radius: 2px;
  position: relative;
  animation: animate 0.3s;
  padding-bottom: 10px;
  @media (max-width: 768px) {
        align-self: center;
        justify-self: center;
        width: 95%;
        max-width: 95%;
        height: 70%;
    }
`


const PollQuestion = styled.div`
    width: 100%;
    border: none; 
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: aliceblue;
    justify-content: start;
    margin-bottom: 10px;
    margin-top: 20px;
    padding: 10px;
    border-radius: 11px;

    @media (max-width: 768px) {
        margin-top: 10px;
        width: 90%;
    }

    & input{
        background-color: aliceblue;
        padding: 10px;
        width: 100%;
        outline: none;
        border: none;
    }
`
const PollInput = styled.div`
    width: 100%;
    /* border: 1px solid var(--themeColor); */
    background-color: aliceblue;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 11px;
    display: flex;
    flex-direction: row;

    @media (max-width: 768px) {
        width: 90%;
    }
    & input{
        border-radius: 5px;
        background-color: aliceblue;
        padding: 10px;
        width: 100%;
        outline: none;
        border: none;
    }
    & button{
        background-color: aliceblue;
        border: 1px solid var(--themeColor);
        color: var(--themeColor);
        padding: 10px; 
        outline: none;
        border-radius: 6px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer
    }
`
const PollResponsesWrap = styled.div`
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const PRIC = styled.div`
    
    padding: 9px;
    border: 1px solid lightgrey;
    border-radius: 5px;
    width: 100%;
    color: #505050;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
        width: 90%;
        margin-bottom: 5px;
    }

`
const ClearChoice = styled.div`
    display: flex;
    padding: 3px;
    border: 1px solid lightgrey;
    align-items: center;
    cursor: pointer;
    &:hover{
        background-color: lightgray;
    }
` 
